import { LocalStorage } from 'quasar';

export function setPage({ commit }, value) {
  commit('setPage', value);
}

export function setAnswer({ commit }, payload) {
  commit('setAnswer', payload);
}
export function addReport({ commit }, payload) {
  commit('addReport', payload);
}
export function deleteReports({ commit }, payload) {
  commit('deleteReports', payload);
}
export function deleteProfiles({ commit }, payload) {
  commit('deleteProfiles', payload);
}
export function setAnswerMulti({ commit }, payload) {
  commit('setAnswerMulti', payload);
}
export function setSearch({ commit }, value) {
  commit('setSearch', value);
}
export function setFilteredResults({ commit }, value) {
  commit('setFilteredResults', value);
}
export function setProfile({ commit }, value) {
  commit('setProfile', value);
}
export function setResponse({ commit }, value) {
  commit('setResponse', value);
}
export function setAllUsers({ commit }, value) {
  commit('setAllUsers', value);
}
export function setAllReports({ commit }, value) {
  commit('setAllReports', value);
}
export function updateReport({ commit }, payload) {
  commit('updateReport', payload);
}
export function saveReport({ commit }, payload) {
  commit('saveReport', payload);
}

export function newUser({ commit }, payload) {
  commit('newUser', payload);
}
export function updateUser({ commit }, payload) {
  commit('updateUser', payload);
}

export function createProfile({ commit }, profile) {
  let payload = {
    index: profile.favorite_id,
    profile: profile
  };
  commit('createProfile', payload);
}

export function setRequestSearch({ commit }, payload) {
  commit('setRequestSearch', payload);
}

export function getQuestions({ commit }) {
  const questions = LocalStorage.getItem('questions');
  if (questions) {
    commit('setQuestions', questions);
  }
}

export function saveQuestions({ state }) {
  LocalStorage.set('questions', state.questions);
}

export function setReport({ commit }, payload) {
  commit('setReport', payload);
}

export function setReportLoaded({ commit }, payload) {
  commit('setReportLoaded', payload);
}

export function setMultiple({ commit }, payload) {
  commit('setMultiple', payload);
}
